import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-sensor',
  templateUrl: './sensor.component.html',
  styleUrls: ['./sensor.component.css']
})
export class SensorComponent extends BaseComponent implements OnInit {
  sensors: any = []
  sensor: any = {id:0,name:"",description:""}
  sortArray: any = []
  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.loader.show()
    await this.getData()
    this.loader.hide()
  }

  async getData() {
    this.sensors = await this.db.get("sensor", "getSensors")
  }
  selectSensor(s:any){
    this.sensor = s
  }
  addSensor() {
    this.sensor = { id: 0, name: "", description: "" }
  }
  async save() {
    this.loader.show()
    await this.db.post("sensor", "postSensor", this.sensor)
    await this.getData()
    this.loader.hide()
  }
}
